import React, { useState } from 'react';
import { Vibrate } from 'lucide-react';
import { esApp } from '../../utils/plataforma';
import { guardarVibraciones, vibracionesActivas, vibrar } from '../../utils/hapticos';
import { guardarEnCuenta } from '../../utils/preferencias';

/** Encender o apagar las vibraciones al guardar, al borrar o si algo falla. Solo en la app; se guarda en la cuenta. */
export const Vibraciones: React.FC = () => {
  const [activas, setActivas] = useState(vibracionesActivas);
  if (!esApp) return null;

  const cambiar = () => {
    guardarVibraciones(!activas);
    guardarEnCuenta({ vibraciones: !activas });
    setActivas(!activas);
    // Al encenderlas, una de muestra
    if (!activas) vibrar.exito();
  };

  return (
    <div className="border-t border-gray-100 dark:border-gray-700 pt-5">
      <div className="flex items-center gap-3">
        <Vibrate className="w-5 h-5 text-gray-500 dark:text-gray-400 shrink-0" />
        <div className="flex-1">
          <h3 id="titulo-vibraciones" className="text-sm font-semibold text-gray-700 dark:text-gray-300">Vibraciones</h3>
          <p className="text-xs text-gray-400 dark:text-gray-500">
            Una vibración suave al guardar, al borrar o si algo falla. Se guarda en tu cuenta.
          </p>
        </div>
        <button role="switch" aria-checked={activas} aria-labelledby="titulo-vibraciones" onClick={cambiar}
          className={`relative w-12 h-7 rounded-full transition shrink-0 ${
            activas ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'}`}>
          <span className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow transition-transform ${
            activas ? 'translate-x-5' : ''}`} />
        </button>
      </div>
    </div>
  );
};
